module.exports = __webpack_public_path__ + "img/icon-password.4ea42937.svg";